// extracted by mini-css-extract-plugin
export default {"container":"SwitchModeBtn_container__Mn-iX"};